import React, { useEffect, useRef, useState } from 'react';

import { useNotify, useRedirect } from 'react-admin';

import { BeeEditor, EmailEditorLayout, EmailForm } from './components';
import defaultTemplate from './components/default_template';
import { useBackend } from 'resources/common';
import useActivationLinkWarning from './hooks/useActivationLinkWarning';

const EmailCreate = () => {
  const [{ data }, setCall] = useBackend();
  const [emailInfo, setEmailInfo] = useState({
    subject: '',
    name: '',
    language: 'en',
    family: '',
  });
  const emailInfoRef = useRef(emailInfo);
  const notify = useNotify();
  const redirect = useRedirect();
  const {
    showWarning,
    handleEditorChange,
    evaluateContent,
  } = useActivationLinkWarning(emailInfo.family);

  useEffect(() => {
    if (data) {
      redirect(`/emails/${data.result.id}`);
    }
  }, [data, redirect]);

  useEffect(() => {
    evaluateContent(defaultTemplate);
  }, [evaluateContent]);

  const onSave = (jsonFile, htmlFile) => {
    setCall({
      url: '/email_templates',
      method: 'POST',
      body: {
        template: jsonFile,
        html: htmlFile,
        roles: ['product'],
        ...emailInfoRef.current,
      },
    });
  };

  const onError = (error) =>
    notify(`Email create error: ${error.message}`, 'warning');

  return (
    <EmailEditorLayout
      form={
        <EmailForm
          emailInfo={emailInfo}
          setEmailInfo={setEmailInfo}
          emailInfoRef={emailInfoRef}
        />
      }
      editor={
        <BeeEditor
          onSave={onSave}
          onError={onError}
          onChange={handleEditorChange}
        />
      }
      showWarning={showWarning}
    />
  );
};

export default EmailCreate;
